// organize-imports-ignore
import React from 'react';
import { BaseProteinIcon, SVGProps } from './BaseProteinIcon';
import { BEEF, CHICKEN, FISH, LAMB, PORK, SEAFOOD } from './iconPaths';

export const ProteinBeef = (props: SVGProps) => <BaseProteinIcon {...props} {...BEEF} />;

export const ProteinChicken = (props: SVGProps) => <BaseProteinIcon {...props} {...CHICKEN} />;

export const ProteinFish = (props: SVGProps) => <BaseProteinIcon {...props} {...FISH} />;

export const ProteinLamb = (props: SVGProps) => <BaseProteinIcon {...props} {...LAMB} />;

export const ProteinPork = (props: SVGProps) => <BaseProteinIcon {...props} {...PORK} />;

export const ProteinSeafood = (props: SVGProps) => <BaseProteinIcon {...props} {...SEAFOOD} />;
